module.exports = __webpack_public_path__ + "img/logo_panel.404cb204.png";